import React from 'react';
import { Link } from 'react-router-dom';
import blogData from '../../data/blogs.json';

export default function BlogsSectionBlogWhitePattern3() {
    return (
        <React.Fragment>
            <>
                <section className="pt-20 bg-white " style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")', backgroundRepeat: 'no-repeat', backgroundPosition: 'left top'}}>
                    <div className="container px-4 mx-auto">
                        <div className="md:max-w-5xl mx-auto mb-8 md:mb-16 text-center">
                            <span className="inline-block py-px px-2 mb-4 text-xl leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">Blog</span>
                            <h3 className="mb-4 text-4xl md:text-5xl leading-tight text-darkCoolGray-900 font-bold tracking-tighter">Insights from 45 years in the Tool Bag Industry</h3>
                            <p className="mb-10 text-lg md:text-xl text-coolGray-500 font-medium">From manufacturing techniques to tool organization hacks — explore tips, trends, and trade secrets that matter to professionals and retailers alike.</p>
                        </div>
                        <div className="flex flex-wrap -mx-4 mb-12 md:mb-20">
  {/* Blog Card 1 */}
                            <div className="w-full md:w-1/2 lg:w-1/3 px-4 mb-8">
    <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-white flex flex-col h-full">
                                    <Link to={`/blog/${blogData.blogs[0].id}`} className="block overflow-hidden">
        <div className="bg-gray-100 p-4">
                                            <img className="w-full object-cover rounded-md" src={blogData.blogs[0].image} alt={blogData.blogs[0].title} />
        </div>
                                    </Link>
      <div className="p-4 flex-1 flex flex-col">
        <div className="mb-2">
                                            <span className="inline-block py-1 px-3 text-xs leading-5 text-green-500 hover:text-green-600 font-medium uppercase bg-green-100 hover:bg-green-200 rounded-full shadow-sm">
                                                {blogData.blogs[0].category}
                                            </span>
        </div>
                                        <Link to={`/blog/${blogData.blogs[0].id}`} className="mb-2 text-lg md:text-xl leading-tight text-darkCoolGray-900 hover:text-green-600 font-bold hover:underline">
                                            {blogData.blogs[0].title}
                                        </Link>
                                        <p className="text-coolGray-500 mb-4 text-sm md:text-base font-medium flex-1">{blogData.blogs[0].excerpt}</p>
                                        <Link to={`/blog/${blogData.blogs[0].id}`} className="mt-auto inline-block w-full py-2 px-4 bg-green-500 text-white text-center rounded-md font-medium hover:bg-green-600 transition">
                                            Read Post
                                        </Link>
      </div>
    </div>
  </div>

  {/* Blog Card 2 */}
                            <div className="w-full md:w-1/2 lg:w-1/3 px-4 mb-8">
                                <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-white flex flex-col h-full">
                                    <Link to={`/blog/${blogData.blogs[1].id}`} className="block overflow-hidden">
                                        <div className="bg-gray-100 p-4">
                                            <img className="w-full object-cover rounded-md" src={blogData.blogs[1].image} alt={blogData.blogs[1].title} />
                                        </div>
                                    </Link>
                                    <div className="p-4 flex-1 flex flex-col">
                                        <div className="mb-2">
                                            <span className="inline-block py-1 px-3 text-xs leading-5 text-green-500 hover:text-green-600 font-medium uppercase bg-green-100 hover:bg-green-200 rounded-full shadow-sm">
                                                {blogData.blogs[1].category}
                                            </span>
                                        </div>
                                        <Link to={`/blog/${blogData.blogs[1].id}`} className="mb-2 text-lg md:text-xl leading-tight text-darkCoolGray-900 hover:text-green-600 font-bold hover:underline">
                                            {blogData.blogs[1].title}
                                        </Link>
                                        <p className="text-coolGray-500 mb-4 text-sm md:text-base font-medium flex-1">{blogData.blogs[1].excerpt}</p>
                                        <Link to={`/blog/${blogData.blogs[1].id}`} className="mt-auto inline-block w-full py-2 px-4 bg-green-500 text-white text-center rounded-md font-medium hover:bg-green-600 transition">
                                            Read Post
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* Blog Card 3 */}
                            <div className="w-full md:w-1/2 lg:w-1/3 px-4 mb-8">
                                <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-white flex flex-col h-full">
                                    <Link to={`/blog/${blogData.blogs[2].id}`} className="block overflow-hidden">
                                        <div className="bg-gray-100 p-4">
                                            <img className="w-full object-cover rounded-md" src={blogData.blogs[2].image} alt={blogData.blogs[2].title} />
                                        </div>
                                    </Link>
                                    <div className="p-4 flex-1 flex flex-col">
                                        <div className="mb-2">
                                            <span className="inline-block py-1 px-3 text-xs leading-5 text-green-500 hover:text-green-600 font-medium uppercase bg-green-100 hover:bg-green-200 rounded-full shadow-sm">
                                                {blogData.blogs[2].category}
                                            </span>
                                        </div>
                                        <Link to={`/blog/${blogData.blogs[2].id}`} className="mb-2 text-lg md:text-xl leading-tight text-darkCoolGray-900 hover:text-green-600 font-bold hover:underline">
                                            {blogData.blogs[2].title}
                                        </Link>
                                        <p className="text-coolGray-500 mb-4 text-sm md:text-base font-medium flex-1">{blogData.blogs[2].excerpt}</p>
                                        <Link to={`/blog/${blogData.blogs[2].id}`} className="mt-auto inline-block w-full py-2 px-4 bg-green-500 text-white text-center rounded-md font-medium hover:bg-green-600 transition">
                                            Read Post
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* Blog Card 4 */}
                            <div className="w-full md:w-1/2 lg:w-1/3 px-4 mb-8">
                                <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-white flex flex-col h-full">
                                    <Link to={`/blog/${blogData.blogs[3].id}`} className="block overflow-hidden">
                                        <div className="bg-gray-100 p-4">
                                            <img className="w-full object-cover rounded-md" src={blogData.blogs[3].image} alt={blogData.blogs[3].title} />
                                        </div>
                                    </Link>
                                    <div className="p-4 flex-1 flex flex-col">
                                        <div className="mb-2">
                                            <span className="inline-block py-1 px-3 text-xs leading-5 text-green-500 hover:text-green-600 font-medium uppercase bg-green-100 hover:bg-green-200 rounded-full shadow-sm">
                                                {blogData.blogs[3].category}
                                            </span>
                                        </div>
                                        <Link to={`/blog/${blogData.blogs[3].id}`} className="mb-2 text-lg md:text-xl leading-tight text-darkCoolGray-900 hover:text-green-600 font-bold hover:underline">
                                            {blogData.blogs[3].title}
                                        </Link>
                                        <p className="text-coolGray-500 mb-4 text-sm md:text-base font-medium flex-1">{blogData.blogs[3].excerpt}</p>
                                        <Link to={`/blog/${blogData.blogs[3].id}`} className="mt-auto inline-block w-full py-2 px-4 bg-green-500 text-white text-center rounded-md font-medium hover:bg-green-600 transition">
                                            Read Post
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* Blog Card 5 */}
                            <div className="w-full md:w-1/2 lg:w-1/3 px-4 mb-8">
                                <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-white flex flex-col h-full">
                                    <Link to={`/blog/${blogData.blogs[4].id}`} className="block overflow-hidden">
                                        <div className="bg-gray-100 p-4">
                                            <img className="w-full object-cover rounded-md" src={blogData.blogs[4].image} alt={blogData.blogs[4].title} />
                                        </div>
                                    </Link>
                                    <div className="p-4 flex-1 flex flex-col">
                                        <div className="mb-2">
                                            <span className="inline-block py-1 px-3 text-xs leading-5 text-green-500 hover:text-green-600 font-medium uppercase bg-green-100 hover:bg-green-200 rounded-full shadow-sm">
                                                {blogData.blogs[4].category}
                                            </span>
                                        </div>
                                        <Link to={`/blog/${blogData.blogs[4].id}`} className="mb-2 text-lg md:text-xl leading-tight text-darkCoolGray-900 hover:text-green-600 font-bold hover:underline">
                                            {blogData.blogs[4].title}
                                        </Link>
                                        <p className="text-coolGray-500 mb-4 text-sm md:text-base font-medium flex-1">{blogData.blogs[4].excerpt}</p>
                                        <Link to={`/blog/${blogData.blogs[4].id}`} className="mt-auto inline-block w-full py-2 px-4 bg-green-500 text-white text-center rounded-md font-medium hover:bg-green-600 transition">
                                            Read Post
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* Blog Card 6 */}
                            <div className="w-full md:w-1/2 lg:w-1/3 px-4 mb-8">
    <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-white flex flex-col h-full">
                                    <Link to={`/blog/${blogData.blogs[5].id}`} className="block overflow-hidden">
        <div className="bg-gray-100 p-4">
                                            <img className="w-full object-cover rounded-md" src={blogData.blogs[5].image} alt={blogData.blogs[5].title} />
        </div>
                                    </Link>
      <div className="p-4 flex-1 flex flex-col">
        <div className="mb-2">
                                            <span className="inline-block py-1 px-3 text-xs leading-5 text-green-500 hover:text-green-600 font-medium uppercase bg-green-100 hover:bg-green-200 rounded-full shadow-sm">
                                                {blogData.blogs[5].category}
                                            </span>
        </div>
                                        <Link to={`/blog/${blogData.blogs[5].id}`} className="mb-2 text-lg md:text-xl leading-tight text-darkCoolGray-900 hover:text-green-600 font-bold hover:underline">
                                            {blogData.blogs[5].title}
                                        </Link>
                                        <p className="text-coolGray-500 mb-4 text-sm md:text-base font-medium flex-1">{blogData.blogs[5].excerpt}</p>
                                        <Link to={`/blog/${blogData.blogs[5].id}`} className="mt-auto inline-block w-full py-2 px-4 bg-green-500 text-white text-center rounded-md font-medium hover:bg-green-600 transition">
                                            Read Post
                                        </Link>
      </div>
    </div>
  </div>
</div>
        </div>
    </section>
    </>
        </React.Fragment>
    );
}

